import React, { forwardRef } from 'react';
import List from '../../atoms/List';
const Divider = ({ divider, testId }) => {
    const props = {
        'data-breadcrumb-divider': true,
        'aria-hidden': true,
        'data-testid': `${testId}-divider`,
    };
    if (React.isValidElement(divider)) {
        return React.cloneElement(divider, props);
    }
    return React.createElement("span", Object.assign({}, props), divider ?? '/');
};
const ListItem = ({ children, isLastItem, divider, testId, }) => {
    const props = {
        'data-testid': `${testId}-item`,
        'data-breadcrumb-item': isLastItem ? 'current' : true,
        'aria-current': isLastItem ? 'page' : undefined,
    };
    if (!React.isValidElement(children)) {
        return (React.createElement("li", { "data-breadcrumb-list-item": true },
            React.createElement("span", Object.assign({}, props),
                children,
                isLastItem ? null : React.createElement(Divider, { divider: divider, testId: testId }))));
    }
    return (React.createElement("li", { "data-breadcrumb-list-item": true },
        React.cloneElement(children, props),
        isLastItem ? null : React.createElement(Divider, { divider: divider, testId: testId })));
};
const Breadcrumb = forwardRef(function Breadcrumb({ children, divider: rawDivider, testId = 'store-breadcrumb', ...otherProps }, ref) {
    return (React.createElement("nav", Object.assign({ "aria-label": "Breadcrumb", role: "navigation", ref: ref, "data-store-breadcrumb": true, "data-testid": testId }, otherProps),
        React.createElement(List, { "data-breadcrumb-list": true, variant: "ordered" }, React.Children.toArray(children).map((child, index, childrenArray) => {
            const isLastItem = index === childrenArray.length - 1;
            return (React.createElement(ListItem, { isLastItem: isLastItem, divider: rawDivider, key: `breadcrumb-${index}`, testId: testId }, child));
        }))));
});
export default Breadcrumb;
//# sourceMappingURL=Breadcrumb.js.map